/**
 * 入口处理
 */

import store from '@/store';
import router from './router';
import NProgress from 'nprogress';
import routeSetting from '@/config/router';
import appConfig from '@/config/app';
import auth from '@/core/auth';
import validate from '@/utils/validate';

NProgress.configure({ showSpinner: false });

let checkToken = false;
//根据域名匹配路由
handleRoutes();

router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start();

	const hasToken = auth.getToken();
	let { href } = router.resolve({ path: '/login' });
	href = `${appConfig.domain.app}${href}`;

	if (checkToken) { 
		if (validate.isEmpty(hasToken)) {
			document.location.href = href;
		}
	}

	const userInfo = store.getters.userInfo;

	if (validate.isEmpty(userInfo) && hasToken) {
		try {
			await store.dispatch('user/getInfo');
		} catch (error) {
			await store.dispatch('user/resetToken');
			document.location.href = href;
		}
	}

	next();

})

router.afterEach(() => {
	NProgress.done();
})

/**
 * 根据域名匹配路由
 */
function handleRoutes() {
	let hostname = window.location.hostname ? window.location.hostname : document.location.hostname;
	hostname = hostname.split('.');
	let host = hostname.length >= 3 ? host = hostname[0] : 'www';

	let config = routeSetting.config.hasOwnProperty(host) ? routeSetting.config[host] : {};

	if (config) {
		store.dispatch('router/generateRoutes', config.routes);
		router.addRoutes(config.routes);
	}

	checkToken = config.checkToken;
}



// WEBPACK FOOTER //
// ./src/core/runtime.js